export const getCentralOtagoData = () => ({
  name: "Central Otago",
  country: "Nouvelle-Zélande",
  description: "Central Otago est la région viticole la plus méridionale de Nouvelle-Zélande, réputée pour ses vins de Pinot Noir d'altitude. Située dans l'intérieur de l'île du Sud, la région bénéficie d'un climat continental unique avec des étés chauds et des hivers froids.",
  type: "region",
  area: "2,000 ha",
  production: "0.15 million hectolitres",
  climate: "Climat continental avec étés chauds et secs, hivers froids, amplitudes thermiques importantes",
  soil: "Sols schisteux, argileux, calcaires, excellente diversité géologique",
  characteristics: {
    climate: "Climat continental avec étés chauds et secs, hivers froids, amplitudes thermiques importantes",
    soil: "Sols schisteux, argileux, calcaires, excellente diversité géologique",
    viticulture: "Viticulture d'altitude, rendements limités, qualité privilégiée"
  },
  wineStyles: {
    red: "Pinot Noir élégant avec tanins fins, notes de fruits rouges et épices",
    white: "Vins blancs secs et minéraux, avec une belle acidité",
    rosé: "Rosés délicats et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture à Central Otago a commencé dans les années 1980 avec les premiers vignobles commerciaux. Le Pinot Noir est rapidement devenu le cépage emblématique de la région, produisant des vins avec une personnalité unique grâce au climat continental. Aujourd'hui, Central Otago est reconnue pour ses vins rouges de qualité.",
  foodPairing: "Viandes rouges, gibier, fromages affinés, plats d'hiver, cuisine locale",
  subregions: {
    "Bannockburn": {
      name: "Bannockburn",
      description: "Zone viticole traditionnelle produisant des Pinot Noir de qualité",
      area: "400 ha",
      characteristics: "Sols schisteux, climat continental, vins rouges puissants",
      grapeVarieties: ["pinot-noir", "chardonnay", "pinot-gris", "riesling"]
    },
    "Gibbston": {
      name: "Gibbston",
      description: "Vallée viticole produisant des vins élégants et aromatiques",
      area: "300 ha",
      characteristics: "Sols calcaires, climat frais, vins élégants",
      grapeVarieties: ["pinot-noir", "chardonnay", "sauvignon-blanc", "pinot-gris"]
    },
    "Alexandra": {
      name: "Alexandra",
      description: "Zone viticole la plus méridionale, spécialisée dans les vins rouges",
      area: "250 ha",
      characteristics: "Sols argileux, climat continental, vins structurés",
      grapeVarieties: ["pinot-noir", "chardonnay", "riesling"]
    }
  },
  grapeVarieties: [
    {
      name: "Pinot Noir",
      percentage: "80%",
      description: "Cépage emblématique de Central Otago, produisant des vins élégants avec des tanins fins",
      characteristics: "Élégant, tanins fins, fruits rouges",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Chardonnay",
      percentage: "10%",
      description: "Cépage blanc principal, produisant des vins secs et minéraux",
      characteristics: "Sec, minéral, acidité vive",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Pinot Gris",
      percentage: "5%",
      description: "Cépage blanc produisant des vins aromatiques et texturés",
      characteristics: "Aromatique, texturé, notes d'épices",
      wineStyles: "Sec à demi-sec, aromatique"
    },
    {
      name: "Riesling",
      percentage: "3%",
      description: "Cépage blanc produisant des vins secs et aromatiques",
      characteristics: "Sec, aromatique, acidité vive",
      wineStyles: "Sec à demi-sec, aromatique"
    },
    {
      name: "Autres",
      percentage: "2%",
      description: "Autres cépages incluant Sauvignon Blanc et cépages expérimentaux",
      characteristics: "Diversifiés, expérimentaux",
      wineStyles: "Variés selon le cépage"
    }
  ],
  mapAreas: [
    { region: "Bannockburn", x: 169.5, y: -45.0, color: "#4B164C", size: 4 },
    { region: "Gibbston", x: 169.2, y: -44.8, color: "#6d2c7a", size: 3 },
    { region: "Alexandra", x: 169.4, y: -45.2, color: "#8a4a8a", size: 3 }
  ]
}); 